import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authDialog, setAuthDialog] = useState({ open: false, tab: "signup", context: null });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      return data.user;
    } catch (_) {
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const register = async ({ full_name, email, password }) => {
    const { data } = await api.post("/auth/register", { full_name, email, password });
    setUser(data.user);
    return data.user;
  };

  const login = async ({ email, password }) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (_) {}
    setUser(null);
  };

  const openAuth = (opts = {}) => {
    setAuthDialog({ open: true, tab: opts.tab || "signup", context: opts.context || null });
  };
  const closeAuth = () => setAuthDialog({ open: false, tab: "signup", context: null });

  return (
    <AuthCtx.Provider
      value={{
        user,
        loading,
        refresh,
        register,
        login,
        logout,
        openAuth,
        closeAuth,
        authDialog,
        formatApiError,
      }}
    >
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
